import { useEffect, useMemo, useState } from 'react';

function usePagination<T>(items: T[], limit: number) {
  const [currentPage, setCurrentPage] = useState(0);
  const [paginated, setPaginated] = useState<T[]>([]);

  useEffect(() => {
    setCurrentPage(0);
  }, [items, limit]);

  useEffect(() => {
    const start = currentPage * limit;
    const end = start + limit;

    setPaginated(items.slice(start, end));
  }, [items, limit, currentPage]);

  const pagesLength = useMemo(
    () => Math.ceil(items.length / limit),
    [items, limit]
  );

  return {
    currentPage,
    paginated,
    setCurrentPage,
    pagesLength,
  };
}

export { usePagination };
